import { ReactNode } from 'react';
import styles from './product-list-key.module.scss';
import cx from 'classnames';

const KeyIconItem = ({ title, icon }: { title: string; icon: ReactNode }) => {
  return (
    <div
      className={cx(
        'd-flex align-items-center mb-md-3 mb-2 gap-md-3 gap-2',
        styles['product-list-key__icon-item']
      )}
    >
      {icon} <p className="cat-u-theme-typography-label m-0">{title}</p>
    </div>
  );
};

export default KeyIconItem;
